import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { chartTileTitleSx } from "../dashboardChartStyles";

export function ChartTileTitle({ title, onClick }) {
  return (
    <Typography component="button" type="button" onClick={onClick} sx={chartTileTitleSx}>
      {title}
    </Typography>
  );
}

ChartTileTitle.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
